import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  
    useEffect(() => {
      AOS.init({
      duration: 1400, 
      easing: 'ease-in-cubic',
      once: true,
      offset: 80,    
      });
    }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page refresh
    alert('Thank you for your feedback! We appreciate you taking the time to share your thoughts with us.');
  };

  return (
    <div>
      <section className="text-gray-600 body-font relative px-4 sm:px-6 md:px-20">
        <div className="container px-5 py-24 mx-auto flex sm:flex-nowrap flex-wrap">
          <div className="lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative" data-aos="zoom-in">
            <iframe
              width="100%"
              height="100%"
              className="absolute inset-0"
              frameBorder="0"
              title="map"
              marginHeight="0"
              marginWidth="0"
              scrolling="no"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.73246465538!2d73.01545917440708!3d33.56032674354694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df93a9a3a74f01%3A0x59615813bf26118f!2sEZ%20Technologies%20%26%20Learning%20Hub!5e0!3m2!1sen!2s!4v1740575516831!5m2!1sen!2s"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0, filter: 'grayscale(1) contrast(1.2) opacity(0.4)' }}
            ></iframe>
            <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md">
              <div className="lg:w-1/2 px-6">
                <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">ADDRESS</h2>
                <p className="mt-1">
                  1st Floor, Mansehra Plaza, Above MCB Bank, Opposite Attock Petrol Pump, Near Sunder Marriage Hall,
                  Chakri Road, Rawalpindi, Pakistan
                </p>
              </div>
              <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
                <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">EMAIL</h2>
                <a href="mailto:info@eztechnologies.info" className="text-indigo-500 leading-relaxed">
                  info@eztechnologies.info
                </a>
                <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">PHONE</h2>
                <p className="leading-relaxed">
                  0315-5606668
                  <br />
                  051-5126110
                </p>
              </div>
            </div>
          </div>
          <div className="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0" data-aos="zoom-in">
            <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">Feedback</h2>
            <p className="leading-relaxed mb-5 text-gray-600">
              Help us serve you better! Let us know what you liked or how we can improve.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="relative mb-4">
                <label htmlFor="name" className="leading-7 text-sm text-gray-600">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div className="relative mb-4">
                <label htmlFor="email" className="leading-7 text-sm text-gray-600">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div className="relative mb-4">
                <label htmlFor="message" className="leading-7 text-sm text-gray-600">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full text-black font-fancy font-bold bg-[#d6b055] border-0 py-2 px-6 focus:outline-none hover:bg-black hover:text-white rounded text-lg"
              >
                Send
              </button>
            </form>
            <p className="text-xs text-gray-500 mt-3">
              Thank you for your feedback! We appreciate you taking the time to share your thoughts with us.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
